import { render, staticRenderFns } from "./add-section.html?vue&type=template&id=340ca6a2&scoped=true&"
import script from "./add-section.vue?vue&type=script&lang=js&"
export * from "./add-section.vue?vue&type=script&lang=js&"
import style0 from "./add-section.css?vue&type=style&index=0&id=340ca6a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340ca6a2",
  null
  
)

export default component.exports